import type { Task, TaskHistory } from '../types/Task';
import type { User } from '../types/User';

type HistoryUser = Pick<User, 'name' | 'lastName'> | null | undefined;

function formatUserName(user: HistoryUser): string | null {
  if (!user) return null;
  const name = `${user.name ?? ''} ${user.lastName ?? ''}`.trim();
  return name || null;
}

/**
 * Resolves "By …" label for a task history row.
 * For creation entries, falls back to task.createdBy when history.user is missing.
 */
export function getTaskHistoryAttribution(
  history: Pick<TaskHistory, 'stage' | 'user'>,
  task?: Pick<Task, 'createdBy'> | null
): string {
  const fromHistory = formatUserName(history.user);
  if (fromHistory) {
    return `By ${fromHistory}`;
  }

  if (history.stage === 'created') {
    const fromTask = formatUserName(task?.createdBy);
    if (fromTask) {
      return `By ${fromTask}`;
    }
  }

  return 'By System';
}
